import { WindowScroll } from "@aihub/core/utils";
import {
    AfterViewInit,
    Directive,
    ElementRef,
    Host,
    NgZone,
    OnDestroy,
    Optional,
    Renderer2,
    SkipSelf,
} from "@angular/core";
import { Subject } from "rxjs";
import {
    distinctUntilChanged,
    map,
    startWith,
    take,
    takeUntil,
} from "rxjs/operators";

@Directive({
    selector: "[aihubStickyDirective]",
})
export class AihubStickyDirective implements AfterViewInit, OnDestroy {
  private placeholder: HTMLDivElement;

  private destroy$: Subject<boolean> = new Subject();

  public constructor(
    @Optional() @Host() @SkipSelf() private hostEl: ElementRef,
    private windowScrollObserver: WindowScroll,
    private el: ElementRef,
    private renderer: Renderer2,
    private zone: NgZone
  ) {}

  /**
   * content and all childrens are rendered
   *
   */
  public ngAfterViewInit(): void {
      this.zone.onStable.pipe(take(1)).subscribe(() => {
          const top = this.el.nativeElement.offsetTop - 70;
          this.registerOnScroll(top);
      });
  }

  /**
   * directive gets destroyed
   *
   */
  public ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.complete();
      this.destroy$ = null;
  }

  /**
   * listen to scroll change event
   *
   */
  private registerOnScroll(startOn: number) {
      this.placeholder = this.createPlaceholder();
      this.windowScrollObserver
          .onChange()
          .pipe(
              startWith({ x: 0, y: window.scrollY }),
              map((position) => position.y > startOn),
              distinctUntilChanged(),
              takeUntil(this.destroy$)
          )
          .subscribe((isSticky) => this.toggleSticky(isSticky));
  }

  /**
   * create ghost element which holds the place until
   *
   */
  private createPlaceholder(): HTMLDivElement {
      const sourceBounds = (
      this.el.nativeElement as HTMLElement
      ).getBoundingClientRect();
      const placeholder = this.renderer.createElement("div");

      this.renderer.setStyle(placeholder, "display", `none`);
      this.renderer.setStyle(placeholder, "height", `${sourceBounds.height}px`);
      this.renderer.setStyle(placeholder, "width", `${sourceBounds.width}px`);

      this.renderer.insertBefore(
          this.hostEl.nativeElement,
          placeholder,
          this.el.nativeElement
      );
      return placeholder;
  }

  /**
   * toggle sticky mode
   *
   */
  private toggleSticky(sticky: boolean) {
      this.renderer.setStyle(
          this.el.nativeElement,
          "position",
          sticky ? "fixed" : null
      );
      this.renderer.setStyle(
          this.el.nativeElement,
          "top",
          sticky ? "70px" : null
      );
      this.renderer.setStyle(
          this.el.nativeElement,
          "width",
          sticky ? "100%" : null
      );
      this.renderer.setStyle(
          this.el.nativeElement,
          "z-index",
          sticky ? "5000" : null
      );
      this.renderer.setStyle(
          this.placeholder,
          "display",
          sticky ? "block" : null
      );
  }
}
